import axios from 'axios'
import Utils from '../../../common/utils';

export default {
  search: function (request) {
    return axios.get('/api/organizations/search', { params: request })
  },
  find: function (id) {
    return axios.get('/api/organizations/find?id='+id)
  },
  save: function (data) {
    return axios.post('/api/organizations/save', data)
  },
  delete: function (id) {
    return axios.delete('/api/organizations/delete?id='+id)
  },
  exportWord: function(id,) {
    return Utils.downloadFile('/api/organizations/exportWord?organizationId='+id)
  },
  importExcel: function(name, file) {
    let formData = new FormData();
    formData.append('file', file);
    return axios.post( `/api/organizations/import`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
    );
  }
}